
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-outdoorsy",
      function () {
        return require("private-next-pages/why-outdoorsy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/why-outdoorsy"])
      });
    }
  